import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaCheck, FaLightbulb, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaQuestionCircle, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const Quiz_form = () => {
    useAuth(); // Vérifier l'authentification
    const location = useLocation();
    const [showInfo, setShowInfo] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [dejaVu, setDejaVu] = useState(null);
    const [isLoading, setIsLoading] = useState(false);



    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Quiz";
        }
    }, [user_id]);

    const lancerQuiz = async () => {
        if (dejaVu === null) {
            showAlert('Veuillez faire un choix', 'danger');
            return;
        }
        setIsLoading(true)
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/lancer-quiz/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    dejaVu: dejaVu,
                }),
            });
            const data = await response.json();

            if (response.ok) {
                navigate('/Quizz-demarrer');
            } else {
                console.error("Erreur lors du lancement du quiz :", await response.text());
                showAlert(data.error, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Quiz")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }




    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><FaQuestionCircle size={25} className='mr-2' />Quiz
                            </h2>
                            <small>
                                formulaire de configuration du quiz.
                            </small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Demarrer-jeux`}> Quiz </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="container mt-5 wrapper wrapper-content animated fadeInRight">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h5>Préférences du quiz</h5>
                                    </div>
                                    <div className="ibox-content">
                                        <form onSubmit={(e) => {
                                            e.preventDefault(); // Empêcher le rechargement de la page
                                            lancerQuiz(); // Appeler la fonction manuellement
                                        }}>
                                            <p>Voulez-vous inclure les questions déjà vues ?</p>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="radio"
                                                    id="includeYes"
                                                    name="includeSeen"
                                                    value="Oui"
                                                    onChange={() => setDejaVu(true)}
                                                />
                                                <label htmlFor="includeYes" className="ml-2">Oui</label>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="radio"
                                                    id="includeNo"
                                                    name="includeSeen"
                                                    value="Non"
                                                    onChange={() => setDejaVu(false)}
                                                />
                                                <label htmlFor="includeNo" className="ml-2">Non</label>
                                            </div>
                                            {isLoading ? (
                                                <button className="btn btn-success mr-2" disabled>
                                                    <i className="fa fa-spinner fa-spin mr-1"></i>
                                                    <span className="d-none d-sm-inline ml-2">
                                                        Chargement...
                                                    </span>
                                                </button>
                                            ) : (
                                                <button type="submit" className="btn btn-success mt-3">Commencer</button>
                                            )}
                                        </form>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Quiz_form;
